import React, { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: ReactNode;
}

export const BodyPortal: React.FC<Props> = ({ children }) => {
  if (!document.body) {
    return null;
  }

  return createPortal(children, document.body);
};
